import React, { useState, useEffect, useMemo, useCallback, useContext } from "react";
import DataTable from "react-data-table-component";
import { getBatchesList1 } from "../../../services/index";
import toast, { Toaster } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import EditIcon from "@mui/icons-material/Edit";
import Loader from "../../Common/Loader";
import Tooltip from '@mui/material/Tooltip';
import Select from "react-select";
import { getFormattedNumber } from "../../utils/textUtils";
import { BATCH_URL } from "../../../CONSTANTS";
import PaginationDataTable from "../../Common/PaginationDataTable";
import { AuthUrlContext } from "../../../context/createContext";
import { ThumbUp } from "@mui/icons-material";
import TextArea from "antd/lib/input/TextArea";
import { Button, Col, FormControl, InputGroup, Modal, Row } from "react-bootstrap";
import { approveBatchrecord } from "../../../services/Production/BatchesServices";
import { storeOptionsByWarehouseId } from "../../../services/Purchase/StoreService";
import { getRackByStore } from "../../../services/Purchase/RackService";
import { getCellByRack, getPalletByCell } from "../../../services/Purchase/CellService";
import { Input } from "antd";

const BatchList = (props) => {
    const { userRights } = useContext(AuthUrlContext);
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [search, setSearch] = useState("");
    const [refreshFlag, setRefreshFlag] = useState(0);
    const [approve, setApprove] = useState({ id: "", visible: false, quantity: "", selectedRow: {} })
    const [approveForm, setApproveform] = useState({ quantity: "", batchStatusNotes: "", beanBatchStockTransferList: [{ batchQuantitySelected: "", storeId: "", rackId: "", cellId: "", palletId: "", storeTitle: "", rackTitle: "", cellTitle: "", rackTitle: "", palletTitle: "", RackOptions: [], PalletOptions: [], cellOptions: [] }] })
    const [storeOptions, setStoreOptions] = useState([])
    const [rackOptions, setRackOptions] = useState([])
    const [cellOptions, setCellOptions] = useState([])
    const [palleteOptions, setPalleteOptions] = useState([])

    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);
    const { urlList, userRole } = userRights;

    useEffect(() => {
        const result = rows.filter((data) => {
            return (
                data.batchItemsList[0]?.itemTitle.toLowerCase().includes(search.toLowerCase()) ||
                data.batchItemsList[0]?.batchNo.toLowerCase().includes(search.toLowerCase()) ||
                data.batchItemsList[0]?.batchName.toLowerCase().includes(search.toLowerCase()) ||
                data.productionDate.toLowerCase().includes(search.toLowerCase()) ||
                data.warehouseTitle.toLowerCase().includes(search.toLowerCase())
            );
        });
        setFilteredData(result);
    }, [search]);

    const columns = useMemo(
        () => [
            {
                name: "BATCH NO.",
                style: { color: "#007bff" },
                selector: (row) => `${row.batchItemsList[0]?.batchName} [${row.batchItemsList[0]?.batchNo}]`,
            },
            {
                name: "PRODUCTION DATE",
                selector: (row) => row?.productionDate,
            },
            {
                name: "MFG. DATE",
                selector: (row) => row?.productionMfgDate || "NA",
            },
            {
                name: "EXPIRY DATE",
                selector: (row) => row?.productionExpDate || "NA",
            },
            {
                name: "ITEM NAME",
                selector: (row) => row.batchItemsList[0]?.itemTitle,
                style: {
                    width: "250px",
                    minWidth: "250px",
                    maxWidth: "250px"
                },
                grow: 1.5
            },
            {
                name: "QUANTITY",
                selector: (row) =>
                    getFormattedNumber(row.batchItemsList[0]?.quantity) +
                    " " +
                    row.batchItemsList[0]?.quantityUnitTitle,
            },
            {
                name: "ACTION",
                selector: (row) => (
                    <div>
                        {(userRole === "ROLE_SUPER_ADMIN" || (urlList && urlList.has("/batches/approve"))) && row?.batchStatusEnum != "Approved" ? <div><ThumbUp style={{ fontSize: "15px", cursor: "pointer", color: "greenyellow" }}
                            onClick={() => {
                                handleApprove(row);
                            }} />
                            <EditIcon
                                style={{ fontSize: "15px", cursor: "pointer", marginLeft: "10px" }}
                                onClick={() => {
                                    navigate("/batches/" + row.recordId + "/edit");
                                }}
                            /></div> : <>
                            -
                        </>}
                    </div>
                ),
            },
            {
                name: "QC STATUS",
                selector: (row) => {
                    const status = row?.physicalQualityCheckEnum;
                    const colors = { Accept: "rgb(000 200,000)", Reject: "red", Pending: "grey", Hold: "yellow" };
                    return <span style={{ marginLeft: "25px", background: "black", width: "8px", height: "8px", borderRadius: "50%", display: "inline-block", backgroundColor: colors[status] }} title={row?.physicalQualityCheckEnum}></span>;
                },
                style: {
                    width: "40px",
                    textAlign: "center",
                },
            }
        ], [handleRefresh]
    )
    const handleApprove = (row) => {
        setApprove({ id: row.recordId, visible: true, quantity: row.batchItemsList[0].quantity, selectedRow: row })
        setApproveform((prev) => { return { ...prev, quantity: row.batchItemsList[0].quantity, uuid: row.recordId } })
        storeOptionsByWarehouseId(row?.warehouseId).then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setStoreOptions(options);
            } else {
                toast.error(res.message)
            }
        });
    }
    const handleCancel = () => {
        setApprove({ id: "", visible: false, selectedRow: {} });
        setApproveform({ quantity: "", batchStatusNotes: "", beanBatchStockTransferList: [{ batchQuantitySelected: "", storeId: "", rackId: "", cellId: "", palletId: "", storeTitle: "", rackTitle: "", cellTitle: "", rackTitle: "", palletTitle: "", RackOptions: [], PalletOptions: [], cellOptions: [] }] })
    };
    const handleSubmit = () => {
        const { beanBatchStockTransferList, ...restApproveForm } = approveForm;
        const cleanedBeanBatchStockTransferList = beanBatchStockTransferList.map((batch) => {
            const { RackOptions, PalletOptions, cellOptions, ...cleanedBatch } = batch;
            return cleanedBatch;
        });
        const cleanedForm = {
            ...restApproveForm,
            beanBatchStockTransferList: cleanedBeanBatchStockTransferList,
        }
        // Every batch row must have Qty, Store, Rack, Cell and Pallet, and the rows must add up to Quantity.
        const validationError = Validatebatch(cleanedForm);
        if (validationError) {
            toast.error(validationError);
            return;
        }
        approveBatchrecord(cleanedForm)
            .then((res) => {
                if (res.errorCode === 0) {
                    toast.success(res.message);
                    handleRefresh()
                } else {
                    toast.error(res.message);
                }
            })
            .catch((error) => {
                toast.error("Submission failed. Please try again.");
            })
        setApprove({ id: "", visible: false });
        setApproveform({ quantity: "", batchStatusNotes: "", beanBatchStockTransferList: [{ batchQuantitySelected: "", storeId: "", rackId: "", cellId: "", palletId: "", storeTitle: "", rackTitle: "", cellTitle: "", rackTitle: "", palletTitle: "", RackOptions: [], PalletOptions: [], cellOptions: [] }] })
    }

    const handleRowClick = (row) => {
        if (props.onRowClicked) {
            props.onRowClicked(row);
        }
        const recordId = row.recordId;
        if (recordId) {
            navigate(`/batches/${recordId}`, { state: { warehouseId: row?.warehouseId } });
        }
    };

    const handleClickNew = () => {
        navigate('/batches/new');
    };


    const handleSelectChange = async (e, name, index) => {
        const updatedBeanBatchStockTransferList = [...approveForm.beanBatchStockTransferList];
        if (name === 'storeId') {
            const RackOptionsforbatch = await getRackList(e.value)
            updatedBeanBatchStockTransferList[index] = {
                ...updatedBeanBatchStockTransferList[index],
                storeId: e.value,
                rackId: "",
                cellId: "",
                palletId: "",
                storeTitle: e.label,
                rackTitle: "",
                cellTitle: "",
                palletTitle: "",
                RackOptions: RackOptionsforbatch
            };
            getRackByStore(e.value).then((res) => {
                if (res.errorCode === 0) {
                    const options = res.responsePacket?.map((d) => ({
                        value: d.key,
                        label: d.value,
                    }));
                    setRackOptions(options);
                } else {
                    toast.error(res.message);
                }
            });
        }

        if (name === 'rackId') {
            let cellOptionsforbatch = await getCellList(e.value)
            updatedBeanBatchStockTransferList[index] = {
                ...updatedBeanBatchStockTransferList[index],
                rackId: e.value,
                cellId: "",
                palletId: "",
                rackTitle: e.label,
                palletTitle: "",
                cellTitle: "",
                CellOptions: cellOptionsforbatch

            };
            getCellByRack(e.value).then((res) => {
                if (res.errorCode === 0) {
                    const options = res.responsePacket?.map((d) => ({
                        value: d.key,
                        label: d.value,
                    }));
                    setCellOptions(options);
                } else {
                    toast.error(res.message);
                }
            });
        }

        if (name === 'cellId') {
            let palleteOptionsforbatch = await getPalleteOptions(e.value)
            updatedBeanBatchStockTransferList[index] = {
                ...updatedBeanBatchStockTransferList[index],
                cellId: e.value,
                palletId: "",
                cellTitle: e.label,
                palletTitle: "",
                PalletOptions: palleteOptionsforbatch
            };
            getPalletByCell(e.value).then((res) => {
                if (res.errorCode === 0) {
                    const options = res.responsePacket?.map((d) => ({
                        value: d.key,
                        label: d.value,
                    }));
                    setPalleteOptions(options);
                } else {
                    toast.error(res.message);
                }
            });
        }

        if (name === 'palletId') {
            updatedBeanBatchStockTransferList[index] = {
                ...updatedBeanBatchStockTransferList[index],
                palletId: e.value,
                palletTitle: e.label,
            };
        }
        if (name === "selectedQuantity") {
            updatedBeanBatchStockTransferList[index] = {
                ...updatedBeanBatchStockTransferList[index],
                batchQuantitySelected: e
            }
        }
        setApproveform((prev) => ({
            ...prev,
            beanBatchStockTransferList: updatedBeanBatchStockTransferList,
        }));
    };

    const addMore = () => {
        setApproveform((prev) => { return { ...prev, beanBatchStockTransferList: [...prev.beanBatchStockTransferList, { storeId: "", rackId: "", cellId: "", palletId: "", storeTitle: "", rackTitle: "", cellTitle: "", rackTitle: "" }] } })
    }
    const removeBatch = (index) => {
        setApproveform((prev) => {
            const updatedList = prev.beanBatchStockTransferList.filter(
                (item, idx) => idx !== index
            );
            return {
                ...prev,
                beanBatchStockTransferList: updatedList,
            };
        });
    };

    const getRackList = async (uuid) => {
        let data = [];
        try {
            let res = await getRackByStore(uuid);
            const _res = res.responsePacket?.map((item) => ({
                label: item.value,
                value: item.key
            }));
            data = _res;
        } catch (error) {
            return [];
        }

        return data;
    };

    const getCellList = async (uuid) => {
        let data = []
        try {
            let res = await getCellByRack(uuid)
            const _res = res.responsePacket?.map((item) => ({
                label: item.value,
                value: item.key
            }));
            data = _res;
        }
        catch {
            return [];
        }
        return data;
    }

    const getPalleteOptions = async (uuid) => {
        let data = []
        try {
            let res = await getPalletByCell(uuid)
            const _res = res.responsePacket?.map((item) => ({
                label: item.value,
                value: item.key
            }));
            data = _res;
        }
        catch {
            return [];
        }
        return data;
    }


    // Returns an error message when the approve form is incomplete, otherwise null.
    const Validatebatch = (data) => {
        const quantity = parseFloat(data?.quantity);
        if (isNaN(quantity) || quantity <= 0) {
            return "Quantity must be greater than 0";
        }

        const batches = data?.beanBatchStockTransferList || [];
        if (batches.length === 0) {
            return "At least one batch row is required";
        }

        const seen = [];
        let total = 0;
        for (let i = 0; i < batches.length; i++) {
            const b = batches[i];
            const rowLabel = `batch row ${i + 1}`;
            const qty = parseFloat(b?.batchQuantitySelected);
            if (isNaN(qty) || qty <= 0) {
                return `Qty must be greater than 0 for ${rowLabel}`;
            }
            if (!b?.storeId) {
                return `Store is required for ${rowLabel}`;
            }
            if (!b?.rackId) {
                return `Rack is required for ${rowLabel}`;
            }
            if (!b?.cellId) {
                return `Cell is required for ${rowLabel}`;
            }
            if (!b?.palletId) {
                return `Pallet is required for ${rowLabel}`;
            }
            const key = `${b.storeId}-${b.rackId}-${b.cellId}-${b.palletId}`;
            if (seen.includes(key)) {
                return `Duplicate Store/Rack/Cell/Pallet in ${rowLabel}`;
            }
            seen.push(key);
            total += qty;
        }

        if (Math.abs(total - quantity) > 0.0001) {
            return `Total batch qty (${total}) must equal Quantity (${quantity})`;
        }
        return null;
    };

    return (
        <>
            <div style={{ height: 500, width: "100%" }}>
                <PaginationDataTable
                    paginationUrl={
                        BATCH_URL() + "getAllRecords"
                    }
                    refresh={refreshFlag}
                    serverSidePagination={true}
                    search={true}
                    pagination={false}
                    columns={columns}
                    onRowClicked={handleRowClick}
                    onNewClicked={handleClickNew}
                    showWareHouse={true}
                />
            </div>
            <Toaster />
            <Modal
                show={approve.visible}
                onHide={handleCancel}
                size="lg"
            >
                <Modal.Header>
                    <Modal.Title><div style={{ display: "flex", justifyContent: "space-between" }}><text>{`${approve?.selectedRow?.batchItemsList?.[0]?.itemTitle}-${approve?.selectedRow?.batchItemsList?.[0].batchName}`}</text><text>{`${approve?.selectedRow?.warehouseTitle}`}</text></div></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <InputGroup className="mb-3">
                        <text style={{ marginRight: "5px", width: "100px" }}>Quantity <span className="text-danger">*</span>:</text>
                        <FormControl
                            placeholder="Quantity"
                            aria-label="Quantity"
                            value={approveForm?.quantity}
                            style={{ width: '200px', minWidth: '200px', maxWidth: '200px' }}
                            onChange={(e) => setApproveform((prev) => { return { ...prev, quantity: e.target.value } })}
                        />
                    </InputGroup>
                    <Row> <text style={{ marginLeft: "14px", width: "85px", marginRight: "5px" }}>Batches :</text> <Button onClick={addMore}>Add More +</Button></Row>

                    {approveForm?.beanBatchStockTransferList?.map((srcp, index) => {
                        return (
                            <Row key={index} className="mb-3" >
                                <Col sm={3} md={2}>
                                    <text style={{ marginRight: '5px' }}>Qty<span className="text-danger">*</span>:</text>
                                    <FormControl style={{ width: "90%" }} value={srcp?.batchQuantitySelected} onChange={(e) => handleSelectChange(e.target.value, "selectedQuantity", index)}>
                                    </FormControl></Col>
                                <Col sm={6} md={3}>
                                    <text style={{ marginRight: '5px' }}>Store<span className="text-danger">*</span>:</text>
                                    <Select
                                        style={{ width: '100%' }}
                                        placeholder="Select a store"
                                        options={storeOptions}
                                        onChange={(e) => handleSelectChange(e, "storeId", index)}
                                        value={{ label: srcp?.storeTitle, value: srcp?.storeId }}
                                    />
                                </Col>

                                <Col sm={4} md={2}>
                                    <text style={{ marginRight: '5px' }}>Rack<span className="text-danger">*</span>:</text>
                                    <Select
                                        style={{ width: '100%' }}
                                        placeholder="Select a rack"
                                        onChange={(e) => handleSelectChange(e, "rackId", index)}
                                        options={srcp?.RackOptions}
                                        value={{ label: srcp?.rackTitle, value: srcp?.rackIdId }}
                                    />
                                </Col>

                                <Col sm={2} md={2}>
                                    <text style={{ marginRight: '5px' }}>Cell<span className="text-danger">*</span>:</text>
                                    <Select
                                        style={{ width: '100%' }}
                                        placeholder="Select a cell"
                                        onChange={(e) => handleSelectChange(e, "cellId", index)}
                                        options={srcp?.CellOptions}
                                        value={{ label: srcp?.cellTitle, value: srcp?.cellId }}
                                    />
                                </Col>

                                <Col sm={5} md={2}>
                                    <text style={{ marginRight: '5px' }}>Pallet<span className="text-danger">*</span>:</text>
                                    <Select
                                        style={{ width: '100%' }}
                                        placeholder="Select a pallet"
                                        onChange={(e) => handleSelectChange(e, "palletId", index)}
                                        options={srcp?.PalletOptions}
                                        value={{ label: srcp?.palletTitle, value: srcp?.palletId }}
                                    />
                                </Col>
                                <Col sm={1} md={1}>
                                    <text style={{ marginRight: '5px' }}>Remove:</text><Button disabled={approveForm.beanBatchStockTransferList.length === 1} onClick={() => {
                                        removeBatch(index)
                                    }}>X</Button></Col>
                            </Row>
                        );
                    })}


                    <InputGroup className="mb-3">
                        <text style={{ marginRight: "5px", width: "100px" }}>Notes :</text>
                        <FormControl
                            as="textarea"
                            placeholder="Write Something..."
                            value={approveForm?.batchStatusNotes}
                            onChange={(e) => setApproveform((prev) => { return { ...prev, batchStatusNotes: e.target.value } })}
                        />
                    </InputGroup>
                </Modal.Body>


                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCancel}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default BatchList;
